import type { ReportRow } from '../../models/report.types'

export function finiteNumber(value: unknown): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export function category(value: unknown): string {
  return String(value ?? '-')
}

export function uniqueCategories(rows: readonly ReportRow[], field: string): string[] {
  const seen = new Set<string>()
  return rows.flatMap((row) => {
    const value = category(row[field])
    if (seen.has(value)) return []
    seen.add(value)
    return [value]
  })
}

export function groupRows(
  rows: readonly ReportRow[],
  field: string | undefined,
): Map<string, ReportRow[]> {
  const groups = new Map<string, ReportRow[]>()
  if (!field) {
    groups.set('', [...rows])
    return groups
  }
  for (const row of rows) {
    const key = category(row[field])
    const group = groups.get(key) ?? []
    group.push(row)
    groups.set(key, group)
  }
  return groups
}
